export const ActionTypes = {
  FETCH_OPERATOR_SKILL_OPERATIONS: 'services/operatorSkillOperation/fetch_operator_skill_operations',
  SET_OPERATOR_SKILL_OPERATIONS: 'services/operatorSkillOperation/set_operator_skill_operations',
  SET_OPERATOR_SKILL_OPERATIONS_LOADER_STATUS:
    'services/operatorSkillOperation/set_operator_skill_operations_loader_status',
  ADD_UPDATE_OPERATOR_SKILL_OPERATION: 'services/operatorSkillOperation/add_update_operator_skill_operation',
  DELETE_OPERATOR_SKILL_OPERATION: 'services/operatorSkillOperation/delete_operator_skill_operation',
};

const fetchOperatorSkillOperations = ({ operatorSkillOperationsParams }) => ({
  operatorSkillOperationsParams,
  type: ActionTypes.FETCH_OPERATOR_SKILL_OPERATIONS,
});

const setOperatorSkillOperations = ({ operatorSkillOperationsData }) => ({
  operatorSkillOperationsData,
  type: ActionTypes.SET_OPERATOR_SKILL_OPERATIONS,
});

const setOperatorSkillOperationsLoaderStatus = ({ operatorSkillOperationsLoader }) => ({
  operatorSkillOperationsLoader,
  type: ActionTypes.SET_OPERATOR_SKILL_OPERATIONS_LOADER_STATUS,
});

const addUpdateOperatorSkillOperation = ({ actionName, operatorSkillOperationObj, operatorSkillOperationsParams }) => ({
  actionName,
  operatorSkillOperationObj,
  operatorSkillOperationsParams,
  type: ActionTypes.ADD_UPDATE_OPERATOR_SKILL_OPERATION,
});

const deleteOperatorSkillOperation = ({ operatorSkillId, operatorSkillOperationsParams }) => ({
  operatorSkillId,
  operatorSkillOperationsParams,
  type: ActionTypes.DELETE_OPERATOR_SKILL_OPERATION,
});

export default {
  fetchOperatorSkillOperations,
  setOperatorSkillOperations,
  setOperatorSkillOperationsLoaderStatus,
  addUpdateOperatorSkillOperation,
  deleteOperatorSkillOperation,
};
